"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Square = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm1.674 4.474a1.2 1.2 0 0 0-1.2 1.2v12.652a1.2 1.2 0 0 0 1.2 1.2h12.652a1.2 1.2 0 0 0 1.2-1.2V5.674a1.2 1.2 0 0 0-1.2-1.2z"
      fill="#333"
    />
    <path
      d="M9.342 8.95h4.909a.8.8 90 0 1 .8.8v4.908a.8.8 90 0 1-.8.8H9.342a.8.8 90 0 1-.8-.8V9.749a.8.8 90 0 1 .8-.8"
      fill="#333"
    />
  </>,
  "Square",
  { viewBox: "0 0 24 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
